import React, { ChangeEvent, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button } from 'react-bootstrap';

import Rating from '../components/Rating/Rating';

import api from '../services/apiClient';
import { useAuth } from '../hooks/auth';

import '../css/inputBox.css';
import '../css/suporteRation.css';

const SupportRating = (): any => {
  const {
    dataConnection,
    idRequestSupport,
    urlLogoEmpresaCliente,
    loadLogoEmpresaCliente,
  } = useAuth();
  const navigate = useNavigate();

  const [ratingConhecimento, setRatingConhecimento] = useState(1);
  const [ratingSimpatia, setRatingSimpatia] = useState(1);
  const [ratingReceptividade, setRatingReceptividade] = useState(1);
  const [ratingAvaliacaoGeral, setRatingAvaliacaoGeral] = useState(1);
  const [ratingComentario, setRatingComentario] = useState('');

  useEffect(() => {
    const linkEmpresaCache = String(
      localStorage.getItem('@LiveChat:linkEmpresa')
    );

    loadLogoEmpresaCliente(linkEmpresaCache);
  }, []);

  const handleSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): Promise<void> => {
    e.preventDefault();

    const data = {
      seqAtendimento: idRequestSupport,
      notaConhecimento: ratingConhecimento,
      notaSimpatia: ratingSimpatia,
      notaReceptividade: ratingReceptividade,
      notaGeral: ratingAvaliacaoGeral,
      comentario: ratingComentario,
    };

    const token = localStorage.getItem('@LiveChat:token');

    const result = await api.post('/AvaliacaoAtendimento', data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const { success } = result.data;
    if (success) {
      navigate('/');
    }
  };

  return (
    <div className="div-main">
      <div className=" sectionA">
        <img src="/assets/LiveChatLogoRating.svg" alt="Live-Chat Logo" />
      </div>
      <div className="sectionB px-lg-2 pt-lg-2 px-xxl-3 pt-xxl-3">
        <div className="sectionB-logo">
          <img src={urlLogoEmpresaCliente} alt="Logo Cliente" />
        </div>
        <p className="title mt-lg-1 fw-bold">Avalie-nos, por favor</p>
        <p className="subtitle mb-lg-1">
          Valorizamos sua opinião! Compartilhe seu feedback sobre o atendimento
          para que possamos aprimorar nossos serviços e garantir a melhor
          experiência possível para você.
        </p>
        <div>
          <Container className="p-0 m-0">
            <Form>
              <div className="d-flex flex-column  ps-1 h-auto vw-auto align-items-center justify-content-center">
                <Rating
                  textCaption="Conhecimento"
                  value={setRatingConhecimento}
                />
                <Rating textCaption="Simpatia" value={setRatingSimpatia} />
                <Rating
                  textCaption="Receptividade"
                  value={setRatingReceptividade}
                />
                <Rating
                  textCaption="Avaliação Geral"
                  value={setRatingAvaliacaoGeral}
                />

                <div className="w-100 h-100">
                  <Form.Group controlId="message">
                    <Form.Control
                      className="inputBox mt-3 mb-4"
                      rows={3}
                      style={{ height: 'auto', maxHeight: '3rem' }}
                      as="textarea"
                      type="text"
                      placeholder="Comentário"
                      name="message"
                      onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                        const element = e.target;

                        // Ajusta a altura dinamicamente com base no conteúdo digitado
                        element.style.height = 'auto';
                        element.style.height = `${element.scrollHeight}px`;
                        setRatingComentario(e.target.value);
                      }}
                    />
                  </Form.Group>
                </div>

                <Button
                  type="submit"
                  className="bnt-enviar"
                  onClick={(e) => handleSubmit(e)}
                >
                  Enviar
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default SupportRating;
